import React, { useState } from "react";
import { MenuItem, Props } from "./types";

export function ManualPanelMenu({ model, activePath, navigate }: Props) {
  const [openGroups, setOpenGroups] = useState<Set<string>>(new Set());

  const toggleGroup = (label: string) => {
    const newOpenGroups = new Set(openGroups);
    if (newOpenGroups.has(label)) {
      newOpenGroups.delete(label);
    } else {
      newOpenGroups.add(label);
    }
    setOpenGroups(newOpenGroups);
  };

  const getPlClass = (level: number) => {
    const step = 1;
    const maxPl = 8;
    const plValue = Math.min(level * step + 4, maxPl);
    return `px-${plValue}`;
  };

  const renderItems = (items: MenuItem[], level = 0) => (
    <ul className="list-none m-0 pl-0">
      {items.map(({ label, icon, path, items: subItems }) => {
        const isOpen = openGroups.has(label);
        const isActive = path === activePath;

        const paddingClass = getPlClass(level);

        return (
          <li key={label}>
            <div
              className={`
                flex align-items-center cursor-pointer user-select-none
                py-3 w-full p-panelmenu
                ${paddingClass} 
                ${isActive ? "sidebar-active" : ""}
              `}
              onClick={() => {
                if (subItems) {
                  toggleGroup(label);
                } else if (path) {
                  navigate(path);
                }
              }}
            >
              {icon && <i className={`pi ${icon} mr-2`}></i>}
              <span>{label}</span>
              {subItems && (
                <i
                  className={`pi pi-chevron-${isOpen ? "down" : "right"} ml-auto`}
                ></i>
              )}
            </div>
            {subItems && isOpen && renderItems(subItems, level + 1)}
          </li>
        );
      })}
    </ul>
  );

  return <nav>{renderItems(model)}</nav>;
}
